import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ModalCalculateComponent } from 'src/app/modules/report-management/modal-calculate/modal-calculate.component';

@Component({
  selector: 'lifedi-report-four-box-template',
  templateUrl: './report-four-box-template.component.html',
  styleUrls: ['./report-four-box-template.component.scss']
})
export class ReportFourBoxTemplateComponent implements OnInit {
  @Input() reportForm: FormGroup;
  @Input() reportType: string;
  @Input() reportID: string;
  @Input() measureID: string;
  @Input() isEdit: boolean;
  @Input() isPaid: boolean;

  calStatus: boolean = false;

  constructor(
    private fb: FormBuilder,
    public matDialog: MatDialog,
  ) { }

  ngOnInit(): void {
    // console.log(this.reportForm);

    if (this.reportForm.value.PSY_BLOCKS.length === 0 && this.reportForm.value.CHART_DATA.length === 0) {
      this.addGroup();
      this.addChart();
    }
  }

  openCalculateModal(form, i, isEdit) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      reportId: this.reportID,
      measureId: this.measureID,
      isEdit: isEdit,
      title: 'คำนวณ',
      calData: form.value.CAL,
      typeReport: this.reportType,
      actionBtnText: 'บันทึก',
    }

    const modal = this.matDialog.open(ModalCalculateComponent, dialogConfig);
    modal.afterClosed().pipe(
      map(res => {
        if (res.status) {
          form.get('CAL').patchValue(res.data);
          form.get('CAL').updateValueAndValidity();
        }
      }),
      catchError((err) => {
        // console.log(err);
        alert(err.error.message)
        return of(null);
      }),
    ).subscribe();
  }

  addGroup() {
    this.psyBlocksArr.push(this.fb.group({
      PSY_BLOCKS_ID: [`BK${new Date().getTime()}`, Validators.required],
      PSY_NAME: ['', Validators.required],
      COLOR_CODE: ['', Validators.required],
      DETAIL_PSY: ['', Validators.required],
      CAL: [null, Validators.required]
    }))
  }

  addChart() {
    this.chartDataArr.push(this.fb.group({
      LEFTBT_BOX: this.fb.group({
        TYPE_NAME: ['', Validators.required],
        COLOR_BOX: ['', Validators.required],
        COLOR_TEXT: ['', Validators.required],
        DESCRIPTION: ['', Validators.required],
        LEFT_BOT: this.fb.group({
          X: ['', Validators.required],
          Y: ['', Validators.required]
        }),
        LEFT_TOP: this.fb.group({
          X: ['', Validators.required],
          Y: ['', Validators.required]
        }),
        RIGHT_BOT: this.fb.group({
          X: ['', Validators.required],
          Y: ['', Validators.required]
        }),
        RIGHT_TOP: this.fb.group({
          X: ['', Validators.required],
          Y: ['', Validators.required]
        })
      }),
      LEFTTOP_BOX: this.fb.group({
        TYPE_NAME: ['', Validators.required],
        COLOR_BOX: ['', Validators.required],
        COLOR_TEXT: ['', Validators.required],
        DESCRIPTION: ['', Validators.required],
        LEFT_BOT: this.fb.group({
          X: ['', Validators.required],
          Y: ['', Validators.required]
        }),
        LEFT_TOP: this.fb.group({
          X: ['', Validators.required],
          Y: ['', Validators.required]
        }),
        RIGHT_BOT: this.fb.group({
          X: ['', Validators.required],
          Y: ['', Validators.required]
        }),
        RIGHT_TOP: this.fb.group({
          X: ['', Validators.required],
          Y: ['', Validators.required]
        })
      }),
      RIGHTBT_BOX: this.fb.group({
        TYPE_NAME: ['', Validators.required],
        COLOR_BOX: ['', Validators.required],
        COLOR_TEXT: ['', Validators.required],
        DESCRIPTION: ['', Validators.required],
        LEFT_BOT: this.fb.group({
          X: ['', Validators.required],
          Y: ['', Validators.required]
        }),
        LEFT_TOP: this.fb.group({
          X: ['', Validators.required],
          Y: ['', Validators.required]
        }),
        RIGHT_BOT: this.fb.group({
          X: ['', Validators.required],
          Y: ['', Validators.required]
        }),
        RIGHT_TOP: this.fb.group({
          X: ['', Validators.required],
          Y: ['', Validators.required]
        })
      }),
      RIGHTTOP_BOX: this.fb.group({
        TYPE_NAME: ['', Validators.required],
        COLOR_BOX: ['', Validators.required],
        COLOR_TEXT: ['', Validators.required],
        DESCRIPTION: ['', Validators.required],
        LEFT_BOT: this.fb.group({
          X: ['', Validators.required],
          Y: ['', Validators.required]
        }),
        LEFT_TOP: this.fb.group({
          X: ['', Validators.required],
          Y: ['', Validators.required]
        }),
        RIGHT_BOT: this.fb.group({
          X: ['', Validators.required],
          Y: ['', Validators.required]
        }),
        RIGHT_TOP: this.fb.group({
          X: ['', Validators.required],
          Y: ['', Validators.required]
        })
      }),
      X_VALUE: this.fb.group({
        PSY_BLOCKS_ID: ['', Validators.required],
        X_PSY: ['', Validators.required],
        X_PSY_DES: ['']
      }),
      Y_VALUE: this.fb.group({
        PSY_BLOCKS_ID: ['', Validators.required],
        Y_PSY: ['', Validators.required],
        Y_PSY_DES: ['']
      }),
    }))
  }

  selectPsyBlocks(form, e, type) {
    let v = this.reportForm.value.PSY_BLOCKS.filter(b => b.PSY_BLOCKS_ID == e.target.value);

    if (type === 'X') {
      form.patchValue({
        X_VALUE: {
          X_PSY: v[0].PSY_NAME
        }
      })
    } else {
      form.patchValue({
        Y_VALUE: {
          Y_PSY: v[0].PSY_NAME
        }
      })
    }

    form.updateValueAndValidity();
    // console.log(form);
  }

  removePsyBlocks(i) {
    this.psyBlocksArr.removeAt(i);
  }

  removeChartData(i) {
    this.chartDataArr.removeAt(i);
  }

  get psyBlocksArr(): FormArray {
    return this.reportForm.get('PSY_BLOCKS') as FormArray;
  }

  get chartDataArr(): FormArray {
    return this.reportForm.get('CHART_DATA') as FormArray;
  }
}
